import { type AllegatoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/allegatoComunicazioneDTO.ts';
import { Button } from 'antd';
import styled from 'styled-components';
import { useHasDocumentsInlineViewer } from '../../documents/useHasDocumentsInlineViewer.tsx';
import { useCommunicationAttachments } from '../form/attachments/useCommunicationAttachmentDownload.ts';
import { AttachmentItemView } from './AttachmentItemView.tsx';

const AttachmentLink = styled.div`
  // test
  > button {
    font-weight: 400;
    padding-left: 0;
    line-height: 1.2;
    height: auto;
    > div.ant-space {
      border-bottom: 1px solid transparent;
      :hover {
        border-bottom-color: ${props => props.theme.colorPrimary};
      }
      .ant-space-item {
        text-align: left;
      }
    }
  }
`;

export interface IAttachmentItemProps {
  attachment?: AllegatoComunicazioneDTO | null | undefined;
  id?: string | null;
}

/**
 * Singolo allegato della comunicazione
 */
export function AttachmentItem(props: IAttachmentItemProps) {
  const { id, attachment } = props;

  const hasInlineViewer = useHasDocumentsInlineViewer();
  const { download, isFetching } = useCommunicationAttachments({
    attachment,
    hasInlineViewer,
  });

  if (!id || !attachment) return null;

  return (
    <AttachmentLink>
      <Button type="link" loading={isFetching} onClick={download}>
        <AttachmentItemView attachment={attachment} />
      </Button>
    </AttachmentLink>
  );
}
